import React from 'react'
import PropTypes from 'prop-types'
import { useMakeDispatchCallback } from 'hooks'
import { setSelectedIdWithDrawer } from 'actions/navigator'
import { useMakeSelector } from 'hooks/redux'
import { makeGetQueryDescription } from 'selectors/feature/queries'
import { Button, InputLabel } from 'components/patterns'
import strings from 'utils/strings'
import withStyle from './InputtingDataFrom.style'

const InputtingDataFrom = ({ refQueryUri, className }) => {
  const setSelectedIdCallback = useMakeDispatchCallback(setSelectedIdWithDrawer)
  const description = useMakeSelector(makeGetQueryDescription, {
    uri: refQueryUri,
  })

  return (
    <div className={className}>
      <InputLabel vertical label={strings.inputting_data_from_label} />
      <Button
        onClick={() => setSelectedIdCallback(refQueryUri)}
        link
        dataTestId="inputting-data-from-button"
      >
        {description}
      </Button>
    </div>
  )
}

InputtingDataFrom.propTypes = {
  refQueryUri: PropTypes.string.isRequired,
  className: PropTypes.node,
}

export default withStyle(InputtingDataFrom)
